import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ToggleButton from "@mui/material/ToggleButton";
import Box from "@mui/material/Box";
import { alpha, useTheme } from "@mui/material/styles";


interface TabsV2Props
{
  tabIndex: number;
  handleChangeTab: (index: number) => void
}

export const TabsV2 = ({ tabIndex, handleChangeTab }: TabsV2Props) => {
  const theme = useTheme()
  return (
    <Box sx={styles.row}>
      <ToggleButtonGroup
        value={tabIndex}
        exclusive
        onChange={(_, value) => value !== null && handleChangeTab(value)}
        sx={{
          flexWrap: { xs: "nowrap", lg: "wrap" },
          gap: 1,
          justifyContent: { xs: "flex-start", lg: "center" },
          px: { xs: 0.25, lg: 0 },
          "& .MuiToggleButtonGroup-grouped": {
            border: "none",
            borderRadius: "999px !important",
            px: 1.75,
            py: 0.75,
            minWidth: "fit-content",
            whiteSpace: "nowrap",
            color: alpha(theme.palette.text.primary, 0.72),
            backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.04 : 0.55),
            "&.Mui-selected": {
              color: theme.palette.common.white,
              background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.info.main})`,
            },
          },
        }}
      > 
        <ToggleButton style={styles.item} value={0} >MACD</ToggleButton>
        <ToggleButton style={styles.item} value={1} >EMA Crossover</ToggleButton>
        <ToggleButton style={styles.item} value={2} >Bollinger Bands</ToggleButton>
        <ToggleButton style={styles.item} value={3} >RSI</ToggleButton>
        <ToggleButton style={styles.item} value={4} >MFI</ToggleButton>
        <ToggleButton style={styles.item} value={5} >SMA</ToggleButton>
        <ToggleButton style={styles.item} value={6} >VWAP</ToggleButton>
        <ToggleButton style={styles.item} value={7} >Custom</ToggleButton>
        <ToggleButton style={styles.item} value={8} >Triple EMA</ToggleButton>
        <ToggleButton style={styles.item} value={9} >RSI Crossover</ToggleButton>
        <ToggleButton style={styles.item} value={10} >ADX</ToggleButton>
        <ToggleButton style={styles.item} value={11} >Triple RSI</ToggleButton>
        <ToggleButton style={styles.item} value={12} >Volume Profile</ToggleButton>
        <ToggleButton style={styles.item} value={13} >OBV</ToggleButton>
        <ToggleButton style={styles.item} value={14} >Market</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  )
}

const styles = {
  row: {
    display: "flex",
    width: "100%",
    overflowX: "auto",
    alignSelf: "center",
    justifyContent: "center",
  },
  item: {
    fontSize: 12,
    width: 79
  }
}
